import type { ContractDto } from '@b-stock/contract-api-client'
import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { CommonStrings } from '@b-stock/fe-core/locale'
import {
  type OfferingDto,
  OfferingDtoOfferScopeEnum,
} from '@b-stock/offering-api-client'

import useAccount from '@/buyer-portal/helpers/useAccount'

import { ViewContractDetailsButton } from './ViewContractDetailsButton'
import { ViewOrderDetailsButton } from './ViewOrderDetailsButton'

const ns = 'Offerings.Details.offeringStatusBanner.offerAccepted'

export const OfferAcceptedBanner = ({
  offering,
  contract,
}: {
  offering: OfferingDto
  contract: ContractDto | null
}) => {
  const { data: account } = useAccount(offering.accountId)

  const sellerName = account?.business?.displayName || (
    <CommonStrings.NotAvailableAbbr.Component />
  )

  const isContract = !!contract

  return (
    <>
      <Banner
        title={
          <FormattedMessage
            id={`${ns}.title`}
            values={{
              type: isContract ? 'a contract' : 'an offering',
            }}
          />
        }
        type="success"
      >
        <div>
          <FormattedMessage
            id={
              isContract
                ? `${ns}.contractOfferingMessage`
                : `${ns}.spotOfferingMessage`
            }
            values={{
              sellerName,
            }}
          />
        </div>
        {offering.offerScope === OfferingDtoOfferScopeEnum.Item ? (
          isContract ? (
            <ViewContractDetailsButton listingId={offering.listingId} />
          ) : (
            <ViewOrderDetailsButton listingId={offering.listingId} />
          )
        ) : null}
      </Banner>

      {offering.offerScope === OfferingDtoOfferScopeEnum.Lot && (
        <>
          {isContract ? (
            <ViewContractDetailsButton
              listingId={offering.listingId}
              appearance="primary"
            />
          ) : (
            <ViewOrderDetailsButton listingId={offering.listingId} />
          )}
        </>
      )}
    </>
  )
}
